// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__I_0o-","info":"PatientInfo_info__27Vi_"};